import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import GeneralContracting from './components/GeneralContracting';
import WoodMetalFinishing from './components/WoodMetalFinishing';
import FurnitureObjects from './components/FurnitureObjects';
import HardwareRestoration from './components/HardwareRestoration';
import ArtServices from './components/ArtServices';
import HistoricInteriors from './components/HistoricInteriors';
import ServiceMaintenance from './components/ServiceMaintenance';
import MasonryFireplaces from './components/MasonryFireplaces';
import About from './components/About';
import Media from './components/Media';
import Postcards from './components/Postcards';
import ScrollToTop from "./ScrollToTop"; 

function App() {
    return (
        <HashRouter>
            <ScrollToTop>
            <Routes>
                
                <Route path="/" element={<Home />} />
                <Route path="/general-contracting" element={<GeneralContracting />} />
                <Route path="/wood-metal-finishing" element={<WoodMetalFinishing />} />
                <Route path="/furniture-objects" element={<FurnitureObjects />} />
                <Route path="/hardware-restoration" element={<HardwareRestoration />} />
                <Route path="/art-services" element={<ArtServices />} />
                <Route path="/historic-interiors" element={<HistoricInteriors />} />
                <Route path="/service-maintenance" element={<ServiceMaintenance />} />
                <Route path="/masonry-fireplaces" element={<MasonryFireplaces />} />
                <Route path="/about" element={<About />} />
                <Route path="/media" element={<Media />} />
                <Route path="/postcards" element={<Postcards />} />
            </Routes>
            </ScrollToTop>
        </HashRouter>
    );
}

export default App;
